import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX } from "react";
import { useEmployeeDetailStatusButtons } from "../hooks/useEmployeeDetailStatusButtons";

export const EmployeeDetailStatusButtons = (): JSX.Element | null => {
    const { isVisible, isLoading, onDeactivateClick } =
        useEmployeeDetailStatusButtons();

    if (!isVisible) return null;

    return (
        <div className={"p-employee-detail__status"}>
            <Button
                loading={isLoading}
                variant={"alert"}
                disabled={isLoading}
                onClick={onDeactivateClick}
            >
                Medewerker uit dienst melden
            </Button>
        </div>
    );
};
